import url from '@/shared/lib/url';
import { reportUtilType } from '@/shared/utils/report/report-util-type';
import { FC } from 'react';

interface ReportStntThumbListProps {
    thumbList: EvlInfo[];
    selected: string;
    selectedThumbIndex?: number; // 부모가 관리하는 선택된 썸네일 id
    onThumbClick: (id: number) => void;
    isStudent?: boolean;
}

export const ReportStntThumbList: FC<ReportStntThumbListProps> = ({
    thumbList,
    selected,
    selectedThumbIndex,
    onThumbClick,
    isStudent,
}) => {
    return (
        <div className="tbl-con-left">
            <ul>
                {thumbList.map((thumb, index) => {
                    const contentsNum = index + 1;
                    const thumbnail = thumb?.mdulItemInfo?.thumbnail;
                    const isActive = selectedThumbIndex === index;

                    // 콘텐츠 정보일 때 (썸네일 리스트만 렌더링)
                    if (selected === 'contents') {
                        return (
                            <li
                                key={thumb?.mdulEvlInfo?.id}
                                className={isActive ? 'on' : ''}
                                onClick={() => onThumbClick(index)}
                            >
                                <button aria-label={`${contentsNum}번 문제`}>
                                    <img src={url.src(thumbnail)} alt={`${contentsNum}번 문제`} />
                                </button>
                            </li>
                        );
                    }

                    const mrkTy = thumb?.mdulEvlInfo?.mrkTy;
                    const errata = thumb?.mdulEvlInfo?.errata;
                    const eakAt = thumb?.mdulEvlInfo?.eakAt;
                    const submAt = thumb?.mdulEvlInfo?.submAt;

                    // 학생 이름일 때 (정오 표시 렌더링)
                    if (selected === 'student') {
                        const { thumbType, labelStr } = reportUtilType.errataType(
                            mrkTy,
                            errata,
                            eakAt,
                            submAt
                        );

                        let thumbClassName = thumbType;

                        /**
                         * 학생이고 수동채점, 채점 전 일때 class 미표시
                         * isStudent = true / 학생
                         * mrkTy = 2 / 수동채점
                         * errata = 4 or null / 채점불가(채점 전)
                         */
                        if (isStudent && mrkTy === 2 && (errata === 4 || errata === null)) {
                            thumbClassName = '';
                        }

                        return (
                            <li
                                key={thumb.mdulEvlInfo?.id}
                                className={`${isActive ? 'on' : ''} ${thumbClassName}`}
                                aria-label={`${contentsNum}번 문제${labelStr}`}
                                title={labelStr.trim()}
                                onClick={() => onThumbClick(index)}
                            >
                                <button aria-label={`${contentsNum}번 문제${labelStr}`}>
                                    <img src={url.src(thumbnail)} alt={`${contentsNum}번 문제`} />
                                </button>
                            </li>
                        );
                    }

                    return null;
                })}
            </ul>
        </div>
    );
};
